// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { BrandModel } from "@insite/client-framework/Types/ApiModels";
import { getBrands, GetBrandsApiParameter } from "@insite/client-framework/Services/BrandService";

type GetFeaturedBrandsParameter = {
    brandsId: string[];
    onSuccess?: (result: BrandModel[]) => void;
};

type HandlerType = ApiHandler<GetFeaturedBrandsParameter, BrandModel[]>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        const apiParam: GetBrandsApiParameter = { brandIds: props.apiParameter.brandsId };
        const result = await getBrands(apiParam);
        props.apiResult = result.brands || [];
    } catch (error) {
        props.apiResult = [];
        logger.error(error);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameters, RequestDataFromApi, ExecuteOnSuccessCallback];

const loadFeaturedBrands = createHandlerChainRunner(chain, "loadFeaturedBrands");

export default loadFeaturedBrands;
